import { render } from "./active-users-component.vue?vue&type=template&id=1bf6e019&scoped=true"
import script from "./active-users-component.vue?vue&type=script&lang=js"
export * from "./active-users-component.vue?vue&type=script&lang=js"

import "./active-users-component.vue?vue&type=style&index=0&id=1bf6e019&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf6e019"],['__file',"src/assets/js/vue/components/dashboard/active-users-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bf6e019"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bf6e019', __exports__)) {
    api.reload('1bf6e019', __exports__)
  }
  
  module.hot.accept("./active-users-component.vue?vue&type=template&id=1bf6e019&scoped=true", () => {
    api.rerender('1bf6e019', render)
  })

}


export default __exports__